import React, { useState, useEffect } from "react";

function MaintenanceModal({ info, isAdmin, onAdminExit }) {
  const [pendingCount, setPendingCount] = useState(0);
  useEffect(()=>{
    try {
      let count=0;
      for(let i=0;i<localStorage.length;i++){
        const k=localStorage.key(i);
        if(k&&k.startsWith("fz:")&&k.includes(":_pending")) count++;
      }
      setPendingCount(count);
    }catch(e){}
  },[]);

  const endTime = info?.endTime ? new Date(info.endTime) : null;
  const endStr  = endTime ? endTime.toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"}) : "—";

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.88)",zIndex:10000,
      display:"flex",alignItems:"center",justifyContent:"center",padding:20,fontFamily:"'DM Sans',sans-serif"}}>
      <div style={{background:"#111827",border:"2px solid #F59E0B",borderRadius:18,padding:28,maxWidth:480,width:"100%",textAlign:"center"}}>
        <div style={{fontSize:56,marginBottom:12}}>🔧</div>
        <div style={{fontSize:22,fontWeight:800,color:"#F8FAFC",marginBottom:8}}>Sistema em Manutenção</div>
        <div style={{fontSize:14,color:"#94A3B8",marginBottom:16,lineHeight:1.6}}>
          {info?.message||"Sistema temporariamente indisponível para manutenção."}
        </div>
        <div style={{background:"#1F2937",borderRadius:10,padding:"12px 16px",marginBottom:20}}>
          {info?.startTime&&<div style={{fontSize:12,color:"#64748B"}}>
            Início: {new Date(info.startTime).toLocaleString("pt-BR")}
          </div>}
          <div style={{fontSize:14,color:"#F59E0B",fontWeight:700,marginTop:4}}>
            Término previsto: {endStr}
          </div>
        </div>
        {pendingCount>0&&(
          <div style={{fontSize:12,color:"#86EFAC",marginBottom:12}}>
            ✅ {pendingCount} alteração(ões) local(is) serão sincronizadas quando o sistema voltar.
          </div>
        )}
        {isAdmin&&(
          <button onClick={onAdminExit}
            style={{background:"#374151",border:"1px solid #4B5563",color:"#D1D5DB",
              padding:"8px 20px",borderRadius:8,cursor:"pointer",fontSize:13}}>
            👑 Sair do modo manutenção (Admin)
          </button>
        )}
      </div>
    </div>
  );
}

export default MaintenanceModal;
export { MaintenanceModal };
